import { defaultEmployee, EmployeeDto } from 'src/dtos/employee/employeeDto';
import { defaultHrmFamilyDto, HrmFamilyDto } from 'src/dtos/hrmFamily/hrmFamilyDto';
import { defaultHrmEducationDto, HrmEducationDto } from 'src/dtos/hrmEducation/hrmEducationDto';

/** 사원 한 명의 가족·학력 전체 저장 요청이다. */
export interface HRM1040_R01Dto {
    empNo: string; // 저장 대상 사원번호
    hrmFamilyDtoList: HRM1040_R01FamilyDto[]; // 저장 후 남길 가족 전체
    hrmEducationDtoList: HRM1040_R01EducationDto[]; // 저장 후 남길 학력 전체
}

/** 조회 전용 사원 행이다. */
export interface HRM1040_R01HeaderDto extends EmployeeDto {
    orgNm: string; // 부서명
    positionNm: string; // 직위명
    familyCount: number; // 서버가 조회한 공제 가족 수
    deductFamilyCount: number; // 본인을 포함한 공제 가족 수, 최대 11
}

/** 공통 그리드의 신규 행 상태를 표현하는 화면 전용 행 타입이다. */
export interface HRM1040_R01HeaderGridRow extends HRM1040_R01HeaderDto {
    inserted?: boolean; // 공통 그리드에서 신규 행인지 판별할 때만 사용
}

/** 사원 가족관계 행이다. 화면 전용 필드가 없어 공통 가족 DTO를 그대로 상속한다. */
export interface HRM1040_R01FamilyDto extends HrmFamilyDto { }

/** 사원 학력 행이다. 화면 전용 필드가 없어 공통 학력 DTO를 그대로 상속한다. */
export interface HRM1040_R01EducationDto extends HrmEducationDto { }

/** 사원 목록 기본 행이다. 빈 행 채우기와 서버 행의 누락 필드 보완에 쓴다. */
export const defaultHRM1040_R01HeaderDto: HRM1040_R01HeaderDto = {
    ...defaultEmployee,
    orgNm: '',
    positionNm: '',
    familyCount: 0,
    deductFamilyCount: 1,
};

/** 가족관계 기본 행이다. 신규 행 추가와 빈 행 채우기에 쓴다. */
export const defaultHRM1040_R01FamilyDto: HRM1040_R01FamilyDto = { ...defaultHrmFamilyDto };

/** 학력 기본 행이다. 신규 행 추가와 빈 행 채우기에 쓴다. */
export const defaultHRM1040_R01EducationDto: HRM1040_R01EducationDto = { ...defaultHrmEducationDto };

/** 빈 저장 요청이다. */
export const defaultHRM1040_R01Dto: HRM1040_R01Dto = {
    empNo: '',
    hrmFamilyDtoList: [],
    hrmEducationDtoList: [],
};
